import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { CourseCatalogPostingStream } from 'app/library/course-catalog-landing-page/models/course-catalog-posting-stream.model';
import { CourseCatalogService } from 'app/library/course-catalog/services/course-catalog.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { GeneralAnalyticsService } from '../../../../services/general-analytics.service';

@Component({
    selector: 'app-catalog-postings-dialog',
    templateUrl: './catalog-postings-dialog.component.html',
    styleUrls: ['./catalog-postings-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class CatalogPostingsDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    featuredWidget: CourseCatalogPostingStream[];
    index: number; //The index of the current item in the iterable.
    isFirst: boolean; //True when the item is the first item in the iterable.
    isLast: boolean; //True when the item is the last item in the iterable.

    constructor(
        public dialogRef: MatDialogRef<CatalogPostingsDialogComponent>,
        public tenantDataService: TenantDataService,
        private _router: Router,
        private _locationBasedAnalyticsService: GeneralAnalyticsService,
        private _courseCatalogService: CourseCatalogService
    ) {
        super();
    }

    ngOnInit(): void {
        this.sendPostingViewEvent('page_visit');
    }

    nextPost() {
        this.index++;

        // checks if currently selected post is first, if that's true, we hide prev arrow
        const currentItem = this.featuredWidget[this.index];
        const lastItem = this.featuredWidget[this.featuredWidget.length - 1];

        this.isFirst = false;
        if (lastItem.id === currentItem.id) {
            this.isLast = true;
        } else {
            this.isLast = false;
        }
        this.sendPostingViewEvent('posting_clicked');
    }

    prevPost() {
        this.index--;

        // checks if currently selected post is last, if that's true, we hide next arrow
        const currentItem = this.featuredWidget[this.index];
        const firstItem = this.featuredWidget[0];
        this.isLast = false;
        if (firstItem.id === currentItem.id) {
            this.isFirst = true;
        } else {
            this.isFirst = false;
        }
        this.sendPostingViewEvent('posting_clicked');
    }

    openPostingUrl() {
        const posting = this.featuredWidget[this.index];
        this.sendPostingViewEvent('posting_link_followed');

        // If the url starts with the same domain as the custom domain (whole one, not just base domain) then open internally
        if (posting.url.includes(window.location.host)) {
            this.dialogRef.close();
            const relativePath = new URL(posting.url).pathname;

            if (posting.kind === 'course_category') {
                const categoryId = relativePath.split('/').filter(Boolean).pop();
                if (categoryId) {
                    this._courseCatalogService.setSelectedCategoryId(categoryId);
                }
            }

            void this._router.navigateByUrl(relativePath);
        } else {
            const currentPostUrl = posting.url;
            window.open(currentPostUrl, '_blank');
        }
    }

    async sendPostingViewEvent(eventName: string) {
        const currentPostId = this.featuredWidget[this.index].id;
        const postingResource = this.featuredWidget.find((postings) => postings.id === currentPostId);
        /*  this._locationBasedAnalyticsService.createPostingEvent(
            eventName,
            postingResource.id,
            postingResource.postingType.id,
            postingResource.translation.title,
        ); */
    }
}
